/**
 * Organizer invoice address (user.organisation_settings.invoice_address). Two shapes coexist until every
 * organizer re-saves their details: the legacy comma-separated string ("street, city, country") and, since
 * Modif/621, the object { street_number, city, country, zip_code }. Every reader goes through here.
 * No imports: node:test loads this module directly. Mirrors backend/utils/invoiceAddress.js.
 */
export const INVOICE_ADDRESS_KEYS = ['street_number', 'zip_code', 'city', 'country']

export const EMPTY_INVOICE_ADDRESS = { street_number: '', city: '', country: '', zip_code: '' }

const clean = (value) => (value === null || value === undefined ? '' : String(value).trim())

/** One line for invoices and drawers: "12 rue A, 75001, Paris, France"; '' when unset. */
export const formatInvoiceAddress = (address) => {
    if (!address) return ''
    if (typeof address === 'string') return address.trim()
    if (typeof address !== 'object') return ''
    return INVOICE_ADDRESS_KEYS.map((key) => clean(address[key]))
        .filter(Boolean)
        .join(', ')
}

/** The object shape whatever was stored: a legacy string splits on its commas (street, city, country). */
export const parseInvoiceAddress = (address) => {
    if (!address) return { ...EMPTY_INVOICE_ADDRESS }
    if (typeof address === 'object') {
        return {
            street_number: clean(address.street_number),
            city: clean(address.city),
            country: clean(address.country),
            zip_code: clean(address.zip_code),
        }
    }
    const [street_number = '', city = '', country = ''] = String(address)
        .split(',')
        .map((part) => part.trim())
    return { street_number, city, country, zip_code: '' }
}

/** Enough of an address to invoice (gates: Stripe modal, create-event): a legacy string counts. */
export const hasInvoiceAddress = (address) => {
    if (!address) return false
    if (typeof address === 'string') return address.trim().length > 0
    const parsed = parseInvoiceAddress(address)
    return Boolean(parsed.street_number && parsed.city && parsed.country)
}
